import { ComponentType, isValidElement, memo } from 'react';
import { isEqual, isEqualWith } from 'lodash';

function withDeepMemo<P>(Component: ComponentType<P>) {
  const arePropsEqual = (prevProps: any, nextProps: any) => {
    return Object.entries(prevProps).every(([key, value]) => {
      if (typeof value === 'function' || isValidElement(value)) {
        return true;
      }
      return isEqual(value, nextProps[key]);
    });
  };

  return memo(Component, arePropsEqual);
}

export default withDeepMemo;
